<template>
  <page class="bg-color">
    <div class="choice-type" @click="$router.push({name: 'back-order',query: {orderSn: query.orderSn, stauts: 1, orderGoodsId: query.orderGoodsId, sourceFlag: query.sourceFlag}})">退货退款<van-icon class="arrow" name="arrow" /></div>
    <div class="choice-type-text">商品质量等问题可申请退货</div>
    <div class="choice-type choice-type1" @click="$router.push({name: 'back-order',query: {orderSn: query.orderSn, stauts: 2, type: query.type, orderGoodsId: query.orderGoodsId, sourceFlag: query.sourceFlag}})">换货<van-icon class="arrow" name="arrow" /></div>
    <div class="choice-type-text">颜色尺寸不合适、商品质量等问题可申请换货</div>
  </page>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      query: this.$route.query
    }
  },
  computed: {},
  methods: {},
  created() {
  }
}
</script>

<style lang="stylus" scoped>
.choice-type
  background #ffffff
  height 80px
  line-height 80px
  position relative
  padding-left 80px
  color #333333
  font-size 14px
  border-bottom 1px solid #E5E5E5
.choice-type:before
  width 42px
  height 42px
  content ''
  background url('~@/assets/thtk.png')
  background-size cover
  display block
  position absolute
  left 19px
  top 19px
.choice-type1:before
  background-image url('~@/assets/th.png')
.choice-type .arrow
  width 24px
  height 24px
  line-height 24px
  text-align center
  font-size 18px
  position absolute
  right 7px
  top 28px
  color #b3b3b3
.choice-type-text
  background #ffffff
  height 44px
  line-height 44px
  padding-left 15px
  font-size 14px
  color #999999
  margin-bottom 10px
</style>
